import { render, staticRenderFns } from "./userSinistre.vue?vue&type=template&id=46fcaf40&scoped=true"
import script from "./userSinistre.vue?vue&type=script&lang=js"
export * from "./userSinistre.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46fcaf40",
  null
  
)

export default component.exports